import { flow, set } from 'lodash/fp';

import UrlService from '../../../models/url';

// @ts-expect-error - Automatic, Please fix when editing this file
const customiseSelectedChoosableProduct = (product, onClick) => {
  const selectButton = {
    analyticsLabel: `View ${product?.name} cover`,
    text: 'View cover',
    to: UrlService.getProductUrl(product?.id),
    variants: ['purple'],
  };
  const linkText = 'Edit bundles';
  const bottomLink = { analyticsLabel: linkText, onClick, text: linkText };

  return flow(
    set('customLabel', 'Your customised cover'),
    set('selectButton', selectButton),
    set('bottomLink', bottomLink),
  )(product);
};

export default customiseSelectedChoosableProduct;
